const AboutSection = () => (
  <section id="apropos" className="w-full py-24" style={{ background: 'linear-gradient(135deg, #002060 0%, #0d4fa8 45%, #1a8abf 80%, #4ab8d0 100%)' }}>
    <div className="max-w-5xl mx-auto px-6">
      <div className="flex flex-col items-center text-center">
        {/* Text */}
        <div className="w-full max-w-3xl">
          <span className="text-[#a8e0ef] text-xs font-bold uppercase tracking-widest">Qui sommes-nous ?</span>
          <h2 className="text-4xl lg:text-5xl font-black text-white leading-tight mt-3 mb-6">
            Votre partenaire<br />climatique de confiance
          </h2>
          <p className="text-white/80 text-base leading-relaxed mb-6">
            Basée à Blausasc et intervenant sur l'ensemble de la région de Nice et ses environs, <strong className="text-white">Polar Clim</strong> est votre partenaire de confiance pour toutes vos installations climatiques et thermiques. Forts de notre expertise technique et de nos certifications, nous accompagnons les professionnels et les particuliers dans l'optimisation de leur confort intérieur.
          </p>
          <p className="text-white/80 text-base leading-relaxed mb-10">
            Notre engagement : une rigueur technique absolue, un respect strict des normes environnementales en vigueur et un accompagnement personnalisé à chaque étape de votre projet.
          </p>

          <div className="grid grid-cols-3 gap-4">
            {[
              { icon: 'ri-award-line', label: 'Certifié', sublabel: 'Fluides frigorigènes' },
              { icon: 'ri-map-pin-line', label: 'Nice', sublabel: 'et environs' },
              { icon: 'ri-shield-check-line', label: 'Garantie', sublabel: '5 ans compresseur' },
            ].map(({ icon, label, sublabel }) => (
              <div key={label} className="text-center p-4 bg-white/10 rounded-xl border border-white/20 backdrop-blur-sm">
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2 rounded-lg bg-white/20">
                  <i className={`${icon} text-white text-lg`} />
                </div>
                <p className="font-bold text-white text-sm">{label}</p>
                <p className="text-white/60 text-xs mt-0.5">{sublabel}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AboutSection;
